module.exports = __webpack_public_path__ + "static/icons/icon-recent-forecast-0d55914d713a6ece52a3425ad1425699.svg";